// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__KCzXe","validationTips":"StatementDescriptor_validationTips__2P5In"};